import { BrHeader } from '@govbr-ds/react-components';
import { useAuth } from 'hooks/useAuth';
import { manutencaoArrecadacao } from '../../../environments/environment';
import HeaderAvatar from '../headerAvatar/headerAvatar';
import PGRMLogo from './../../../assets/PGRM-logo-with-text-color.png';
import styles from './header.module.scss';

function Header() {
  const auth = useAuth();
  const urlBase = window.location.origin;

  const name = auth.user?.name || '';
  const image = auth.user?.picture || '';

  const isAmbienteManutencao = manutencaoArrecadacao.isAmbienteManutencao === 'true';

  const demonstraLink = `${urlBase}/demonstra/html/`;

  return (
    <div className={styles.headerContainer}>
      <BrHeader
        className={styles.header}
        quickAccessLinks={[
          {
            label: 'Manual PGRM',
            onClick: () => window.open(demonstraLink, '_blank', 'noopener'),
          },
          {
            label: 'Guia Fácil DIEF-CFEM',
            onClick: () =>
              window.open(
                'https://www.gov.br/anm/pt-br/centrais-de-conteudos/guia-facil/guia-facil-dief-cfem',
                '_blank',
                'noopener'
              ),
          },
        ]}
        menuId='main-navigation'
        loggedIn
        fluid
        avatar={isAmbienteManutencao ? undefined : <HeaderAvatar name={name} image={image} />}
        showMenuButton={!isAmbienteManutencao}
        signature='Agência Nacional de Mineração'
        subTitle='Ministério de Minas e Energia'
        title='Plataforma de Gestão de Recursos Minerais'
        urlLogo={PGRMLogo}
      />
    </div>
  );
}

export default Header;
